"use strict";

import angular from "angular";

import { Events } from "../../presentation/services/Events/Events";

const Event = new Events();

const name = "toEvents";
const factory = [
    "$stateParams",
    ($stateParams) => ({
        restrict: "A",
        link: ($scope, $elem, $attr) => {
            const { company, moduleName, event } = JSON.parse($attr.toEvents);
            angular.element($elem).bind("click", () => {
                if ($stateParams.id) {
                    Event.setParamns({ companyId: $stateParams.id });
                }
                Event.send(`${moduleName + "." + event}`);
            });
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
